module.exports = __webpack_public_path__ + "static/media/check-mark.e1ab8f6d.png";